

































































// vue
import { defineComponent, ref, computed } from '@vue/composition-api';

// components
import EditorText from '@/vue3/components/editor/EditorText.vue';
import EditorActions from '@/vue3/components/editor/EditorActions.vue';
import GeoRecordSelector from '@/vue3/components/geo-record-selector/GeoRecordSelector.vue';
import LinkModelEditor from '@/vue3/components/link-model-editor/LinkModelEditor.vue';

// primevue
import Button from 'primevue/button';

// services
import { useService } from '@/vue3/api/services';

// models
import { GeoRecordModel } from '@/vue3/api/models';

enum ViewState {
    GeometrySelector = 1,
    UploadModel,
    ModelEditor,
}

export default defineComponent({
    components: {
        EditorText,
        EditorActions,
        GeoRecordSelector,
        LinkModelEditor,
        Button,
    },
    props: {
        geoRecords: {
            type: Array,
            default: () => [],
        },
        setIsEditorVisible: {
            type: Function,
            default: () => {},
        },
        refreshTable: {
            type: Function,
            default: () => {},
        },
    },
    setup(props: any) {
        // hooks
        const { createGeoRecordModelMesh, createGeoRecordModel } = useService();

        // reactive
        const geoRecord = ref();
        const currentState = ref(ViewState.GeometrySelector);
        const modelPath = ref('');
        const geoRecordModel = ref<GeoRecordModel>({
            modelSrc: '',
            positionX: 0,
            positionY: 0,
            positionZ: 0,
            rotationX: 0,
            rotationY: 0,
            rotationZ: 0,
            geometry: null,
            scale: 1,
            name: '',
        } as unknown as GeoRecordModel);

        // computed
        const isSaveDisabled = computed(() => {
            switch (currentState.value) {
                case ViewState.GeometrySelector:
                    return (
                        !geoRecordModel.value.name ||
                        !geoRecordModel.value.geometry
                    );
                case ViewState.UploadModel:
                    return false;
                case ViewState.ModelEditor:
                    return false;
                default:
                    return false;
            }
        });

        // methods
        const saveCallback = async () => {
            if (currentState.value === ViewState.ModelEditor) {
                await createGeoRecordModel(geoRecordModel.value);
                props.refreshTable();
                props.setIsEditorVisible(false);
            } else {
                currentState.value++;
            }
        };

        const cancelCallback = () => {
            if (currentState.value === ViewState.GeometrySelector) {
                props.setIsEditorVisible(false);
            } else {
                currentState.value--;
            }
        };

        const uploadModel = async (event: any) => {
            const mesh = event.target.files[0];
            const formData = new FormData();
            formData.append('mesh', mesh, mesh.name);

            const res = await createGeoRecordModelMesh(formData);
            modelPath.value = res.message;
            geoRecordModel.value.modelSrc = res.message;
            currentState.value++;
        };

        return {
            ViewState,
            currentState,
            geoRecord,
            saveCallback,
            cancelCallback,
            modelPath,
            uploadModel,
            geoRecordModel,
            isSaveDisabled,
        };
    },
});
